import {isEmpty} from 'lodash-es';
import type {ReactElement} from 'react';
import {useState} from 'react';

import {Button} from '@/components';
import UpdateRewardModal from '@/screens/Rewards/Card/UpdateRewardModal';
import type {AdminAfriexReward} from '@/types';

import useReward from './useReward';

type RewardButtonProps = {
  initialData?: AdminAfriexReward;
};

const RewardButton = ({initialData}: RewardButtonProps): ReactElement => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const {handleAdd, handleUpdate} = useReward();
  const label = !isEmpty(initialData) ? 'Update Reward' : 'Add New Reward';
  const toggleFullScreen = () => {
    setShowFullScreen(!showFullScreen);
  };

  return showFullScreen ? (
    <UpdateRewardModal
      isOpen={showFullScreen}
      onClose={toggleFullScreen}
      handleSave={!isEmpty(initialData) ? handleUpdate : handleAdd}
      data={initialData}
    />
  ) : (
    <Button variant="solid" colorScheme="cyan" onClick={toggleFullScreen}>
      {label}
    </Button>
  );
};

export default RewardButton;
